import UISimpleTable, { UISimpleTableCell } from "@/components/simple-table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import DataColumn from "./data-column";
import DragNDrop, { DraggableItem } from "@/components/drag-n-drop";
import GridActionPopover from "@/components/page-header/grid-actions-popover";
import { getTagColors } from "@/store/slices/general/dropdownOptionsSlice";
import { useSelector } from "react-redux";
import { DelayUnitEnum, getObjectKeyByValue } from "@/services/dropdown-enums";
let abc = "#978eba";
// drag n drop item stylings
const getItemStyle = (isDragging, draggableStyle) => ({
  background: isDragging ? "#F3F3F3" : "white",
  ...draggableStyle,
});

const columns = [
  { id: 2, title: "Reminders", name: "reminder", align: "left" },
  { id: 4, title: "", align: "center", width: "4px" },
  // { id: 2, title: "Color", name: "color", align: "left" },
  // { id: 3, title: "No. of Leads", name: "leadCount", align: "left" },
  // { id: 3, title: "Probability", align: "left" },
];

export const makeRenderValue = (value, postText = "Before") => {
  const key = getObjectKeyByValue(DelayUnitEnum, value.unit);
  return `${value?.value} ${key} ${postText}`;
};

const ViewTaskType = ({
  data,
  loading,
  setData,
  onSave,
  onEdit,
  onDelete,
  onReOrder,
  permission,
}) => {
  function onDragEnd(result) {
    console.log("result", result);
    onReOrder(result);
  }
  const tagColors = useSelector(getTagColors);

  return (
    <UISimpleTable
      columns={columns}
      containerStyles={{ maxHeight: "calc(100vh - 160px)" }}
      tableClass="border-table"
      tableStyles={{ mt: -1 }}
      containerClass="custom-scroll"
      stickyHeader={true}
      loading={loading}
      hasData={data?.length}
      noDataMessage="No Task Reminder Available"
    >
      <DragNDrop onDragComplete={onDragEnd} data={data}>
        {(provided) => (
          <TableBody ref={provided.innerRef} {...provided.droppableProps}>
            {data.map((row, index) => (
              <DraggableItem
                key={row.id}
                index={index}
                item={row}
                isDragDisabled={!permission?.edit}
              >
                {(provided, snapshot) => (
                  <TableRow
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    // {...provided.dragHandleProps}
                    sx={{ "&:last-child td, &:last-child th": {} }}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style
                    )}
                  >
                    <DataColumn
                      field={"reminder"}
                      index={index}
                      // customChild={
                      //   <Chip
                      //     // size="small"
                      //     sx={{
                      //       fontSize: "0.8rem",
                      //       // height: "18px",
                      //       // ml: 1,
                      //       background: row?.color,
                      //       // color: `${row?.color} !important`,
                      //     }}
                      //     label={row?.name}
                      //     // color={row?.color}
                      //     variant="filled"
                      //   />
                      // }
                      value={makeRenderValue(row)}
                      id={row?.id}
                      // onSave={onSave}
                      showDefaultChip={false}
                      // showDefaultChip={!!row?.isDefault}
                      isDrag={data.length > 1 ? permission?.edit : false}
                      dragHandleProps={{ ...provided.dragHandleProps }}
                      isDragging={snapshot.isDragging}
                      // canEdit={permission?.edit}
                    />
                    {/* <DataColumn
                      customChild={
                        <TagColorPoper
                          callback={(e) => {
                            console.log(e);
                            onSave({ ...row, color: e.id });
                          }}
                          options={tagColors}
                          selected={tagColors.find((t) => t.id == row?.color)}
                        />
                      }
                      // value={tagColors.find((t) => t.id == row?.colorId)?.code}
                    /> */}
                    {/* <DataColumn value={row?.leadCount || 0} /> */}
                    {/* will be open in next version */}
                    {/* <DataColumn
                      field={"probability"}
                      index={index}
                      value={`${row.probability}`}
                      onSave={onSave}
                      postFix="%"
                    /> */}
                    <UISimpleTableCell sx={{ px: 0 }}>
                      <ActionButtons
                        value={row}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        hideDelete={data.length === 1}
                        permission={permission}
                      />
                    </UISimpleTableCell>
                  </TableRow>
                )}
              </DraggableItem>
            ))}
            {provided.placeholder}
          </TableBody>
        )}
      </DragNDrop>
    </UISimpleTable>
  );
};

const ActionButtons = ({
  value,
  onEdit,
  onDelete,
  hideDelete = false,
  permission,
}) => (
  <>
    <GridActionPopover
      options={[
        {
          name: "Edit",
          callback: () => onEdit(value),
          disabled: !permission?.edit,
        },
        {
          name: "Delete",
          callback: () => onDelete(value),
          disabled: !permission?.edit,
        },
      ]}
    />
  </>
);

export default ViewTaskType;
